import { SITE_URL } from '@/lib/seo'

const TITLE_MAX = 120

export interface OgParams {
  title: string
}

export function buildOgUrl(title: string): string {
  const q = new URLSearchParams()
  if (title) q.set('t', title)
  return `${SITE_URL}/og.png?${q.toString()}`
}

export function parseOgQuery(url: URL): OgParams {
  return { title: (url.searchParams.get('t') ?? '').slice(0, TITLE_MAX) }
}
